import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid'

import { Pagination, Spinner } from '@/components/ui'
import { fetchInterventions } from '@/features/interventions/interventionsSlice'
import ResumeView from './InterventionResume'
import ShowView from './InterventionShow'

const InterventionItem = ({item}) => {
  const [view, setView] = useState('resume')

  const toggleView = () => {
    setView(view === 'resume' ? 'show' : 'resume')
  }

  return (
    <div className="relative mb-2 w-full">
      {view === 'resume' ? (
        <ResumeView intervention={item} />
      ) : (
        <ShowView intervention={item} readOnly={true} />
      )}
      <div className="absolute top-4 right-4 flex flex-col items-center">
        <button 
          onClick={toggleView}
          className="btn btn-sm btn-ghost btn-square hover:bg-primary-400"
          title={view === 'resume' ? "Voir les détails" : "Masquer les détails"}
        >
          {view === 'resume' ? <ChevronDownIcon/> : <ChevronUpIcon/>}
        </button>
      </div>
    </div>
  )
}

export default () => {
  const dispatch = useDispatch()
  const interventions = useSelector( state => state.interventions.items )
  const pagination = useSelector((state) => state.interventions.pagination)
  const loading = useSelector( state => state.interventions.loadingStatus.fetchList)

  useEffect(
    () => {
      if(interventions.length == 0) {
        dispatch(fetchInterventions())
      }
    },
    []
  )
  
  const handlePageChange = (page) => {
    // Mettre à jour les filtres avec la nouvelle page
    dispatch(fetchInterventions({page}))
  }

  return (
    <div className='mb-4'>
      <h3 className="text-md font-semibold mb-2">
        Historique de vos interventions
      </h3>
      <div className="bg-primary-100 p-4 rounded-none w-full h-full"> 
        { loading && <Spinner /> }
        { !loading && (
          <>
            <div>
              <div className="flex flex-wrap gap-4">
                { interventions.length === 0 ?
                  <div className="text-center py-4 text-gray-600 italic">
                    Aucune intervention
                  </div> :
                  interventions.map( (item, index) => (
                    <InterventionItem key={index} item={item} /> 
                  ))
                }
              </div>
            </div>
            { pagination.totalPages > 1 && (
              <Pagination
                currentPage={pagination.currentPage}
                totalPages={pagination.totalPages}
                onPageChange={handlePageChange}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}